import { useTranslation } from '@pancakeswap/localization'
import { Currency, CurrencyAmount } from '@pancakeswap/sdk'
import { Box, Flex, Text, Message, ArrowForwardIcon } from '@pancakeswap/uikit'
import { Pool } from '@pancakeswap/v3-sdk'
import { formatCurrencyAmount } from 'utils/formatCurrencyAmount'

interface AutoSwapPreviewProps {
  swapFromCurrency: Currency
  swapToCurrency: Currency
  swapAmount: CurrencyAmount<Currency>
  finalDepositAmount0: CurrencyAmount<Currency>
  finalDepositAmount1: CurrencyAmount<Currency>
  token0Currency: Currency
  token1Currency: Currency
  swapPercentage: number
  pool?: Pool | null
}

export function AutoSwapPreview({
  swapFromCurrency,
  swapToCurrency,
  swapAmount,
  finalDepositAmount0,
  finalDepositAmount1,
  token0Currency,
  token1Currency,
  swapPercentage,
  pool,
}: AutoSwapPreviewProps) {
  const {
    t,
    currentLanguage: { locale },
  } = useTranslation()

  return (
    <Message variant="warning" mb="16px">
      <Box>
        <Text fontSize="14px" bold mb="8px">
          {t('Auto Swap Enabled')}
        </Text>

        {/* Swap Preview - only show if there's a swap */}
        {swapPercentage > 0 ? (
          <Flex alignItems="center" mb="8px">
            <Text fontSize="12px" color="textSubtle">
              {t('Swap')}
              {': '}
            </Text>
            <Flex alignItems="center" ml="4px">
              <Text fontSize="12px" bold>
                {formatCurrencyAmount(swapAmount, 4, locale)} {swapFromCurrency.symbol}
              </Text>
              <ArrowForwardIcon width="16px" mx="4px" color="textSubtle" />
              <Text fontSize="12px" bold color="secondary">
                ~{swapPercentage.toFixed(1)}% {t('of input')}
              </Text>
            </Flex>
          </Flex>
        ) : (
          <Text fontSize="12px" color="success" mb="8px">
            ✓ {t('Using existing wallet balance - no swap needed')}
          </Text>
        )}

        {/* Deposit Preview */}
        <Box mt="8px" p="8px" style={{ backgroundColor: 'rgba(255, 255, 255, 0.05)', borderRadius: '8px' }}>
          <Text fontSize="12px" color="textSubtle" mb="4px">
            {t('Then deposit')}:
          </Text>
          <Flex justifyContent="space-between" mb="4px">
            <Text fontSize="12px">{token0Currency.symbol}:</Text>
            <Text fontSize="12px" bold>
              {formatCurrencyAmount(finalDepositAmount0, 4, locale)}
            </Text>
          </Flex>
          <Flex justifyContent="space-between">
            <Text fontSize="12px">{token1Currency.symbol}:</Text>
            <Text fontSize="12px" bold>
              {formatCurrencyAmount(finalDepositAmount1, 4, locale)}
            </Text>
          </Flex>
        </Box>

        <Text fontSize="11px" color="textSubtle" mt="8px" style={{ fontStyle: 'italic' }}>
          {t('Note: Actual amounts may vary due to price impact and slippage')}
        </Text>
      </Box>
    </Message>
  )
}
